
import { Navigate } from "react-router-dom";
import { ProjectsEndpoints } from "../../../Routes/api/Endpoints";
import { selectData } from "../../../redux/features/userSliceWithTokenValidation";
import { useSelector } from "react-redux";
import { useFetchProjectsQuery } from "../../../services/auth-services/TacheService";
import penseeImageProjet from "../../../assets/penseeprojet.jpg";

export const ProjectsRedirect = () => {
  const { data: projets, error, isLoading } = useFetchProjectsQuery(ProjectsEndpoints.getProjects, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true, 
    skip: false,
  });

  const projetUser = useSelector(selectData);
  const filteredProjects = projets?.filter(
    (proj) => proj.assigned_to_id === projetUser?.id || proj.participants_ids?.includes(projetUser?.id)
  );

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-orange border-opacity-50"></div>
        <p className="mt-4 text-lg font-medium text-gray-600">Chargement des projets...</p>
      </div>
    );
  }

  if (error) {
    return <div>Erreur lors du chargement des projets!</div>;
  }

  if (filteredProjects && filteredProjects.length > 0) {
    return <Navigate to={`${filteredProjects[0].slug}`} />;
  }

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <img
        src={penseeImageProjet}
        alt="No projects found"
        className="w-48 h-48 object-contain"
        loading="lazy"
      />
      <h2 className="text-xl font-semibold text-gray-700">
        Aucun projet disponible pour l'instant
      </h2>
      <p className="text-gray-500">
        Vous n'avez pas encore été assigné à un projet
      </p>
    </div>
  );
};
